import React from "react"
import {sweetalert} from '../../App'
import Select from "react-select"
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil"
import { isEmptyObject } from "jquery"
import { BarcodeTypes } from "../../types/Service"
import { buildRow, getLabel, hideModal } from "../../util/FormatUtil"

interface InternalIdentifierSettingsState{
    selectedService?
    showInBetween
    showLoading
}
interface InternalIdentifierSettingsProps{
    selectedService?
    handleInBetween?
    submit
}
export class InternalIdentifierSettingsModal extends React.Component<InternalIdentifierSettingsProps, InternalIdentifierSettingsState> {
    public static ID = "internalIdentifierSettings"

    constructor(props){
        super(props);
        this.state = {
            showLoading:false,
            showInBetween:false,
        }
    }
    componentWillReceiveProps(nextProps:any,nextContent:any): void {
        if(!isEmptyObject(nextProps.selectedService)){
            let selectedService = JSON.parse(JSON.stringify(nextProps.selectedService))
            let idSettings = selectedService.SpecimenIdSettings
            if(idSettings.length && idSettings.length === 0){
                selectedService.SpecimenIdSettings.push({BarcodeType: "", StartingValue: ""})
            }
            this.setState({selectedService:selectedService})
        }
        else {
            this.setState({
                selectedService: null
            })
        }
    }

    getBarcodeValue(){
        if(!this.state.selectedService){ return }
        if(this.state.selectedService &&
            this.state.selectedService.SpecimenIdSettings &&
            this.state.selectedService.SpecimenIdSettings.length &&
            this.state.selectedService.SpecimenIdSettings.length > 0 &&
            this.state.selectedService.SpecimenIdSettings[0].BarcodeType){
                return {
                    label: BarcodeTypes.find(t=>t.value === this.state.selectedService?.SpecimenIdSettings[0]?.BarcodeType).label,
                    value: BarcodeTypes.find(t=>t.value === this.state.selectedService?.SpecimenIdSettings[0]?.BarcodeType).value
                }
            }
    }

    getStartingValue(){
        if(!this.state.selectedService){ return }
        if(this.state.selectedService &&
            this.state.selectedService.SpecimenIdSettings &&
            this.state.selectedService.SpecimenIdSettings.length &&
            this.state.selectedService.SpecimenIdSettings.length > 0 &&
            this.state.selectedService.SpecimenIdSettings[0].StartingValue){
                return this.state.selectedService?.SpecimenIdSettings[0]?.StartingValue
            }
    }

    render(){
        return(
            <>
            <div className="modal fade form_modal" id={InternalIdentifierSettingsModal.ID} tabIndex={-1} style={{zIndex:100004}} role={"dialog"} aria-labelledby="result_modal_label" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role={"document"}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="result_modal_label">Internal Identifier Settings</h5>
                                <button style={{outline:'none'}} type="button" className="close" 
                                    data-dismiss="modal" aria-label="close" 
                                    onClick={()=>{
                                    this.props.handleInBetween()
                                }}><span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body m-3">
                                <div className="" id="main-modal-content">
                                    {buildRow("Barcode Type", 
                                        <Select
                                            isSearchable={true}
                                            placeholder={"Please Select Barcode Type"}
                                            noOptionsMessage={() => "No options"}
                                            value={this.getBarcodeValue()}
                                            onChange={(e) => {
                                                let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
                                                let newBarcodeType = selectedServiceCopy.SpecimenIdSettings.map(item => {
                                                        return {
                                                            ...item,
                                                            BarcodeType: e.value
                                                        };
                                                })
                                                this.setState((prevState)=>({
                                                    selectedService: {
                                                        ...prevState.selectedService,
                                                        SpecimenIdSettings: newBarcodeType
                                                    }
                                                }))
                                            }}
                                            className={"state_select"}
                                            options={BarcodeTypes}
                                        />, 
                                        'Barcode Type for Accessioning')
                                    }
                                    {buildRow("Starting Value",
                                        <input className={"form-control"}
                                            maxLength={50}
                                            placeholder={"ex. A1001000"}
                                            autoComplete={"off"}
                                            type={"search"}
                                            name={"Starting Value"}
                                            onChange={(e) => {
                                                let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
                                                let newStartingValue = selectedServiceCopy.SpecimenIdSettings.map(item => {
                                                        return {
                                                            ...item,
                                                            StartingValue: e.target.value
                                                        };
                                                })

                                                this.setState((prevState) => ({
                                                    selectedService: {
                                                        ...prevState.selectedService,
                                                        SpecimenIdSettings: newStartingValue
                                                    }
                                                }))
                                            }}
                                            value={this.getStartingValue()}
                                        />,
                                        "Select a starting value for Internal Specimen ID"
                                    )}
                                    <button type="button" className={"btn btn-primary pull-right"} onClick={() => {
                                        //validations
                                        if(!this.state.selectedService.SpecimenIdSettings.length){
                                            return sweetalert.fire("", "Please select a barcode type and starting value", "error")
                                        }
                                        else {
                                            if(!this.state.selectedService.SpecimenIdSettings[0].BarcodeType){
                                                return sweetalert.fire("","Please select a barcode type", "error")
                                            }
                                            if(!this.state.selectedService.SpecimenIdSettings[0].StartingValue){
                                                return sweetalert.fire("","Starting Value canont be blank", "error")
                                            }
                                        }
                                        hideModal(InternalIdentifierSettingsModal.ID)
                                        this.props.handleInBetween()
                                        this.props.submit(this.state.selectedService)
                                    }}>
                                    Submit</button>

                                </div>
                            </div>
                        </div>
                </div>
            </div>
            </>
        )
    }
}